// extracted by mini-css-extract-plugin
export var cardTitle = "_jj-1";
export var commentBubble = "_jj-e";
export var commentForm = "_jj-a";
export var commentInput = "_jj-b";
export var commentLabel = "_jj-d";
export var commentPrompt = "_jj-9";
export var csatCard = "_jj-0";
export var feedbackSection = "_jj-7";
export var starDisabled = "_jj-6";
export var starEmpty = "_jj-5";
export var starFilled = "_jj-4";
export var starWrapper = "_jj-3";
export var starsContainer = "_jj-2";
export var submittedComment = "_jj-c";
export var thankYouText = "_jj-8";